import * as mruTableIdList from './mruTableIdList';
import listViewStore from 'mini-mail-list-store/lib/store/Store';
import TableOperations from 'mini-mail-list-table-operations';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import {
    subscribeToRowNotifications,
    unsubscribeToRowNotifications,
} from '../notifications/rowNotificationsStrategy';

const MRU_TABLES_THRESHOLD: number = 5;
mruTableIdList.initialize(subscribeToRowNotifications, onRemoveTableFromMRU, MRU_TABLES_THRESHOLD);

// Unsubscribe and remove all rows for this table from list view store
// Also remove the table from the store
function onRemoveTableFromMRU(tableViewId: string) {
    unsubscribeToRowNotifications(tableViewId);
    const tableView = listViewStore.tableViews.get(tableViewId);
    TableOperations.clear(tableView);
    listViewStore.tableViews.delete(tableViewId);
}

export default function updateMruTableIdList(tableView: TableView): number | undefined {
    if (tableView.serverFolderId == null) {
        return undefined;
    }

    return mruTableIdList.update(tableView);
}
